<section class="container mx-auto w-full h-full bg-white md:px-10 md:py-16 px-4 py-8">
  <div class="flex flex-col justify-evenly gap-14 md:gap-0 items-center h-full w-full">
    <div class="flex flex-col items-start justify-start gap-4">
      <h2
        i18n="howto|How to join heading@@howto.title"
        class="md:text-3xl text-2xl font-bold text-black"
      >
        How to Join?
      </h2>
    </div>
    <div class="flex flex-col lg:flex-row justify-evenly items-center gap-4 w-full md:mt-14">
      <div class="w-full md:max-w-80 flex flex-col items-center justify-center gap-8">
        <div class="w-full h-full">
          <img
            src="howto_image/how_1.png"
            alt="How to Join? Image"
            class="w-full h-full object-cover"
          />
        </div>
        <div class="flex items-center justify-center gap-2">
          <div
            class="w-10 h-10 bg-main-blue-light text-white font-medium rounded-full flex items-center justify-center"
          >
            1
          </div>
          <p
            i18n="howto|Step 1 label@@howto.step1"
            class="text-black text-sm md:text-base font-medium"
          >
            Select Event or Matches
          </p>
        </div>
      </div>

      <img src="arrow_next.svg" alt="Arrow Next" class="w-10 h-10 max-lg:rotate-90" />

      <div class="w-full md:max-w-80 flex flex-col items-center justify-center gap-8">
        <div class="w-full h-full">
          <img
            src="howto_image/how_2.png"
            alt="How to Join? Image"
            class="w-full h-full object-cover"
          />
        </div>
        <div class="flex items-center justify-center gap-2">
          <div
            class="w-10 h-10 bg-main-blue-light text-white font-medium rounded-full flex items-center justify-center"
          >
            2
          </div>
          <p
            i18n="howto|Step 2 label@@howto.step2"
            class="text-black text-sm md:text-base font-medium"
          >
            Review & Make Payment
          </p>
        </div>
      </div>

      <img src="arrow_next.svg" alt="Arrow Next" class="w-10 h-10 max-lg:rotate-90" />

      <div class="w-full md:max-w-80 flex flex-col items-center justify-center gap-8">
        <div class="w-full h-full">
          <img
            src="howto_image/how_3.png"
            alt="How to Join? Image"
            class="w-full h-full object-cover"
          />
        </div>
        <div class="flex items-center justify-center gap-2">
          <div
            class="w-10 h-10 bg-main-blue-light text-white font-medium rounded-full flex items-center justify-center"
          >
            3
          </div>
          <p
            i18n="howto|Step 3 label@@howto.step3"
            class="text-black text-sm md:text-base font-medium"
          >
            You’re Joined!
          </p>
        </div>
      </div>
    </div>
  </div>
</section>
